module.exports = __webpack_public_path__ + "img/brands-cambio.9be0bf0a.svg";